onSortChanged = function (target) {
    document.body.style.cursor = 'wait'
    var targetSelector = target.dataset.sortTarget;
    var itemsToSort = document.querySelectorAll(targetSelector);
    var itemsToSortArr = Array.prototype.slice.call(itemsToSort);
    var sortArray = itemsToSortArr.map(item => {
        return {
            key: item.getAttribute("data-meta-" + target.value),
            node: item
        }
    });
    var sortedArray = sortArray.sort((a, b) => {
        if (a.key < b.key) //Sortera descending eftersom prepend vill ha det så
            return 1;
        else
            return -1;
    });
    sortedArray.forEach(x => {
        x.node.parentNode.prepend(x.node);
    });
    document.body.style.cursor = 'default'
}

onFilterChanged = function (target) {
    document.body.style.cursor = 'wait'
    var targetSelector = target.dataset.filterTarget;
    var itemsToFilter = document.querySelectorAll(targetSelector);
    var allFiltersForThisTarget = document.querySelectorAll("[data-filter-target='" + targetSelector + "']");

    itemsToFilter.forEach((item) => {
        var shouldShow = true;
        allFiltersForThisTarget.forEach((filter) => {
            if (filter.tagName === "INPUT" && filter.type == "text") {
                if (!(item.textContent.toLowerCase().includes(filter.value.toLowerCase())) && filter.value.length !== 0)
                    shouldShow = false;
            }
            else if (filter.tagName === "SELECT") {
                var metaValue = item.getAttribute("data-meta-" + filter.dataset.filterMeta);
                if (filter.value === "BaseAndDraft") {
                    if (metaValue !== "Base" && metaValue !== "Draft") {
                        shouldShow = false;
                    }
                }
                else if (filter.value === "all") {

                }
                else if (filter.value.length !== 0 && metaValue !== filter.value)
                    shouldShow = false;
            }
        });
        if (shouldShow) {
            if (item.hasAttribute("style")) {
                item.removeAttribute("style");
            }
        }
        else {
            if (!item.hasAttribute("style")) {
                item.style.display = "none";
            }
        }
    });
    document.body.style.cursor = 'default'
}

var filterTargetElements = document.querySelectorAll("[data-filter-target]");
filterTargetElements.forEach(x => {
    x.addEventListener("input", (c) => {
        onFilterChanged(x);
    });
});
if (filterTargetElements.length > 0)
    onSortChanged(filterTargetElements[0]);

var sortTargetElements = document.querySelectorAll("[data-sort-target]");
sortTargetElements.forEach(x => {
    x.addEventListener("input", (c) => {
        onSortChanged(x);
    });
    if (sortTargetElements.length > 0)
        onSortChanged(sortTargetElements[0]);
});